import { Badge } from '@dd3tech/wiggui/Badge'

interface LegendProps {
  zoneCount?: number
  compCount?: number
}

export const Legend = ({ zoneCount, compCount }: LegendProps) => {
  return (
    <div className="flex flex-col w-full gap-2 md:flex-row md:gap-6 md:justify-center">
      {Boolean(zoneCount) && (
        <div className="flex items-center gap-2">
          <Badge
            size="small"
            value={zoneCount}
            customColors={{
              textColor: 'text-primary',
              bgColor: 'bg-notif-blue-01'
            }}
          />
          <span className="text-body-m">Propiedades cercanas</span>
        </div>
      )}

      {Boolean(compCount) && (
        <div className="flex items-center gap-2">
          <Badge
            size="small"
            value={compCount}
            customColors={{
              textColor: 'text-white',
              bgColor: 'bg-notif-blue'
            }}
          />
          <span className="text-body-s">Propiedades comparables</span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_8159_17644)">
            <path
              d="M11.5556 0H4.44444C1.98985 0 0 1.98985 0 4.44444V11.5556C0 14.0102 1.98985 16 4.44444 16H11.5556C14.0102 16 16 14.0102 16 11.5556V4.44444C16 1.98985 14.0102 0 11.5556 0Z"
              fill="#222222"
            />
            <path
              d="M12.4553 11.8011H3.54492V7.73345L8.02339 4.19873L12.4553 7.73526V11.8011ZM4.63322 10.7262H11.3669V8.24925L8.01974 5.57812L4.63322 8.25105V10.7262Z"
              fill="white"
            />
            <path
              d="M8.02797 8.92038C8.52901 8.92038 8.93519 8.51922 8.93519 8.02432C8.93519 7.52941 8.52901 7.12822 8.02797 7.12822C7.52693 7.12822 7.12075 7.52941 7.12075 8.02432C7.12075 8.51922 7.52693 8.92038 8.02797 8.92038Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_8159_17644">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span className="text-body-s">Tu propiedad</span>
      </div>
    </div>
  )
}
